import { createTheme } from '@mui/material/styles';
export const getTheme = (fontFamily) =>{
    return createTheme({
        typography: {
            fontFamily: fontFamily,
            button: {
                textTransform: 'none',
                fontFamily: fontFamily,
                fontSize: '18px',
            },
            h1:{
                fontFamily: fontFamily,
                fontSize:'64px',
                margin:'15px',
                '@media screen and (max-width: 1700px)':{
                    fontSize:'60px',
                },
                '@media screen and (max-width: 1440px)':{
                    fontSize:'58px',
                },
                '@media screen and (max-width:1000px':{
                    fontSize:'40px',
                },
                '@media screen and (max-width:768px':{
                    fontSize:'36px',
                },
                '@media screen and (max-width:440px':{
                    fontSize:'28px',
                }
            },
            h2:{
                fontFamily:fontFamily,
                fontSize:'40px',
                margin:'15px',
                '@media screen and (max-width: 1700px)':{
                        fontSize:'36px',
                    },
                '@media screen and (max-width: 1440px)':{
                        fontSize:'34px',
                    },
                '@media screen and (max-width:1000px':{
                        fontSize:'28px',
                    },
                '@media screen and (max-width:768px':{
                    fontSize:'26px',
                },
                '@media screen and (max-width:440px':{
                    fontSize:'18px',
                }
            },
            body1:{
                fontFamily: fontFamily,
                fontSize:'24px',
                margin:'15px',
                '@media screen and (max-width: 1700px)':{
                        fontSize:'22px',
                    },
                '@media screen and (max-width: 1440px)':{
                        fontSize:'22px',
                    },
                '@media screen and (max-width:1000px':{
                        fontSize:'18px',
                    },
                '@media screen and (max-width:768px':{
                        fontSize:'16px',
                    },
                '@media screen and (max-width:440px':{
                    fontSize:'14px',
                }
            },
        },
        components: {
            MuiTypography:{
                styleOverrides:{
                    root:{
                        color:'var(--text-colour)',
                        transition:'color 0.3s ease',
                        textDecoration:'none',
                    },
                },
            },
            MuiLink:{
                styleOverrides:{
                    root:{
                        fontFamily: fontFamily,
                        color:'var(--link-colour)',
                        textDecoration:'none',
                        '&:hover':{
                            color:'var(--link-hover-colour)',
                        },
                    }
                }
            }
        }
    });
};